import { render, staticRenderFns } from "./luck-draw.vue?vue&type=template&id=80eaff06&scoped=true&"
import script from "./luck-draw.vue?vue&type=script&lang=js&"
export * from "./luck-draw.vue?vue&type=script&lang=js&"
import style0 from "./luck-draw.vue?vue&type=style&index=0&id=80eaff06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80eaff06",
  null
  
)

export default component.exports